import LTPlatform from "../../LTGame/Platform/LTPlatform";
import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import GlobalUnit from "../common/GlobalUnit";
import UI_Custom from "../../ui/Main/UI_Custom";
import { CustomConfig } from "../config/CustomConfig";
import GameData from "../common/GameData";
export class UI_CustomMediator extends BaseUIMediator {
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_CustomMediator();
            this._instance._classDefine = UI_Custom;
        }
        return this._instance;
    }
    _OnShow() {
        super._OnShow();
        // this.ui.m_custom_view.m_state.selectedIndex = 0;
        this.cacheList = CustomConfig.dataList.filter(e => e.level_type == 2);
        this.ui.m_custom_view.m_btn_close.onClick(this, this.Hide);
        this.ui.m_custom_view.m_view_list.setVirtual();
        this.ui.m_custom_view.m_view_list.itemRenderer = Laya.Handler.create(this, this.RenderItem, null, false);
        this.ui.m_custom_view.m_view_list.on(fairygui.Events.CLICK_ITEM, this, this.ClickItem);
        this.ui.m_custom_view.m_view_list.numItems = this.cacheList.length;
        this.ui.m_custom_view.m_view_list.refreshVirtualList();
        LTPlatform.instance.ShowBannerAd();
    }
    RenderItem(index, item) {
        let data = this.cacheList[index];
        item["index"] = index;
        item.m_text_name.text = data.custom_name;
        item.m_text_level.text = data.level_name;
        item.m_img_icon.url = data.icon_path;
        switch (data.unlock_type) {
            case 0:
                item.m_btn_custom.m_c1.selectedIndex = 0;
                break;
            case 1:
                item.m_btn_custom.m_c1.selectedIndex = GameData.instance.customUnlock.indexOf(data.id) == -1 ? 1 : 0;
                break;
            case 2:
                item.m_btn_custom.m_c1.selectedIndex = 1;
                break;
        }
    }
    ClickItem(item) {
        return __awaiter(this, void 0, void 0, function* () {
            let index = item["index"];
            let data = this.cacheList[index];
            switch (data.unlock_type) {
                case 0:
                    this.GoToCustom(data.level_id);
                    break;
                case 1:
                    if (GameData.instance.customUnlock.indexOf(data.id) == -1) {
                        let res = yield LTPlatform.instance.ShowRewardVideoAdAsync();
                        if (res) {
                            GameData.instance.customUnlock.push(data.id);
                            GameData.SaveToDisk();
                            this.GoToCustom(data.level_id);
                        }
                    }
                    else {
                        this.GoToCustom(data.level_id);
                    }
                    break;
                case 2:
                    let res = yield LTPlatform.instance.ShowRewardVideoAdAsync();
                    if (res) {
                        this.GoToCustom(data.level_id);
                    }
                    break;
            }
        });
    }
    GoToCustom(lv_id) {
        this.Hide();
        GlobalUnit.game.startCustomLevel(lv_id);
    }
    _OnHide() {
        LTPlatform.instance.HideBannerAd();
    }
}
